export const coerceBoolean = (value) => {
  if (value === 'true') {
    return true;
  }

  return typeof value === 'string' ? !!+value : !!value;
};
